import XEUtils from "xe-utils";
import httpManager from "../../util/common";
import EntityTitle from '@/entity/components/EntityTitle'
import {entityOaid} from "../../util/util";
import * as d3 from "d3";

let execution_line_chart = {
  components: {EntityTitle},
  name: 'execution-line-chart',
  // props: ['oaid'],
  data: () => {
    return {
      data: [],
      oaid: null,
      report_year: null,
      report_year_options: [],
      report_months: [],
      emissions: ['particulates', 'nox', 'so2', 'vocs', 'ammonia_nitrogen', 'codcr', 'total_phosphorus', 'total_nitrogen'],
      emission_options: null,
      divloading: false
    }
  },
  methods: {
    clearExecutionLineForm () {
      this.data = []
      this.report_year = new Date().getFullYear()
      this.emissions = ['particulates', 'nox', 'so2', 'vocs', 'ammonia_nitrogen', 'codcr', 'total_phosphorus', 'total_nitrogen']
    },
    searchExecutionLineData () {
      this.getExecutionLineData()
    },
    changeOaid () {
      let id = this.$route.params.oaid
      let self = this
      entityOaid.oaid(id).then(result => {
        self.oaid = result
        self.getExecutionLineData()
      })
    },
    getExecutionLineData () {
      let self = this
      if (self.oaid) {
        self.data = []
        self.divloading = true
        let params = new Map()
        params.set('oaid', self.oaid)
        params.set('report_months', self.report_months)
        if (params.length === 0) {
          return
        }
        httpManager('pollution_entity_execution_sum', params, null, null, null)
          .then(response => {
            self.data = response.data.data
            self.drawBarChart()
            self.divloading = false
          })
          .catch(error => {
            console.log(error)
            self.divloading = false
          })
      }
    },
    drawBarChart () {
      let self = this
      let tr = {
        total_nitrogen: this.$t('pollution.total_nitrogen_ton'),
        total_phosphorus: this.$t('pollution.total_phosphorus_ton'),
        codcr: this.$t('pollution.codcr'),
        ammonia_nitrogen: this.$t('pollution.nh3-n'),
        vocs: this.$t('pollution.vocs'),
        so2: this.$t('pollution.so2'),
        nox: this.$t('pollution.nox'),
        particulates: this.$t('pollution.particulates')
      }
      let data = Object.assign(self.data)
      let groupKey = 'reporting_period'
      let keys = ['particulates', 'nox', 'so2', 'vocs', 'ammonia_nitrogen', 'codcr', 'total_phosphorus', 'total_nitrogen']
      let colors = ['#B32D24', '#E8B800', '#01AACF', '#269940', '#D75C00', '#7357E9', '#D131D1', '#2A54F7']
      // let color = d3.scaleOrdinal().range(colors)
      d3.select('#pollutant-emission-line-chart').select('*').remove()
      let height = 260
      let width = 1000
      let svg = d3.select('#pollutant-emission-line-chart').append('svg').attr('viewBox', [0, 0, width, height])
      let margin = ({top: 20, right: 17, bottom: 50, left: 52})
      let xAxis = g => g
        .attr('transform', `translate(0,${height - margin.bottom})`)
        .attr('color', '#333333')
        .call(d3.axisBottom(x0).tickSizeOuter(0))
        .call(g => g.selectAll('.tick text')
          .attr('transform', 'translate(0)rotate(-0)')
          .attr('color', '#333333'))
        .call(g => g.select('.domain').remove())
      let yAxis = g => g
        .attr('transform', `translate(${margin.left},0)`)
        .attr('color', '#333333')
        .call(d3.axisLeft(y))
        .call(g => g.select('.domain').remove())
        .call(g => g.select('.tick:last-of-type text').clone()
          .attr('x', 3)
          .attr('text-anchor', 'start')
          .attr('font-weight', 'bold')
          .text(data.y))
      let x0 = d3.scaleBand()
        .domain(self.report_months)
        .rangeRound([margin.left, width - margin.right])
        .paddingInner(0.0)
      let y = d3.scaleLinear()
        .domain([0, d3.max(data, d => d3.max(this.emissions, key => d[key]))]).nice()
        .rangeRound([height - margin.bottom, margin.top])
      let padding = (width - margin.left - margin.right) / 2 / this.report_months.length - 2
      // 绘制曲线
      for (let i = 0; i < this.emissions.length; ++i) {
        // 创建线生成器
        let pathLine = d3.line()
          .x(d => x0(d[groupKey].slice(0, -3)))
          .y(d => y(d[this.emissions[i]]))
          .defined(d => d[this.emissions[i]])
        svg.append('g')
          .append('path')
          .attr('d', pathLine(data))
          .attr('stroke', colors[keys.indexOf(this.emissions[i])])
          .attr('stroke-width', '1px')
          .attr('fill', 'none')
          .attr('transform', `translate(${padding}, 3)`)
        svg.append('g')
          .selectAll('rect')
          .data(data)
          .enter()
          .append('rect')
          .attr('width', 6)
          .attr('height', 6)
          .attr('x', d => x0(d[groupKey].slice(0, -3)))
          .attr('y', d => y(d[this.emissions[i]]))
          .attr('fill', colors[keys.indexOf(this.emissions[i])])
          .attr('transform', `translate(${padding - 2}, 0)`)
          .style('display', d => d[this.emissions[i]] == null ? 'none' : null)
        let trLeft = width / 2 - 50 * this.emissions.length
        svg.append('g')
          .append('rect')
          .attr('width', 6)
          .attr('height', 6)
          .attr('fill', colors[keys.indexOf(this.emissions[i])])
          .attr('transform', `translate(${i * 100 + trLeft + 47}, ${height - margin.bottom / 2 + 4})`)
        svg.append('g')
          .append('rect')
          .attr('width', 30)
          .attr('height', 2)
          .attr('fill', colors[keys.indexOf(this.emissions[i])])
          .attr('transform', `translate(${i * 100 + trLeft + 35}, ${height - margin.bottom / 2 + 6})`)
        svg.append('text')
          .attr('font-size', '10px')
          .attr('color', '#333333')
          .text(tr[this.emissions[i]])
          .attr('transform', `translate(${i * 100 + trLeft}, ${height - margin.bottom / 2 + 10})`)
      }
      svg.append('g').call(xAxis)
      svg.append('g').call(yAxis)
      // svg.append('g').call(legend)
      svg.node()
    },
    generateReportYearOptions () {
      let date = new Date()
      let year = Number(date.getFullYear())
      this.report_year = year
      this.report_year_options = []
      for (let i = 2017; i <= year; i++) {
        this.report_year_options.push({label: String(i) + '年', value: i})
      }
    }
  },
  mounted () {
    this.generateReportYearOptions()
    this.changeOaid()
    this.news_type_options()
  },
  computed:{
    news_type_options() {
      this.emission_options = [
        {label: this.$t('pollution.particulates_ton'), value: 'particulates'},
        {label: this.$t('pollution.nox_ton'), value: 'nox'},
        {label: this.$t('pollution.so2_ton'), value: 'so2'},
        {label: this.$t('pollution.vocs_ton'), value: 'vocs'},
        {label: this.$t('pollution.nh3-n_ton'), value: 'ammonia_nitrogen'},
        {label: this.$t('pollution.codcr_ton'), value: 'codcr'},
        {label: this.$t('pollution.total_phosphorus_ton'), value: 'total_phosphorus'},
        {label: this.$t('pollution.total_nitrogen_ton'), value: 'total_nitrogen'}
      ]
    },
  },
  watch: {
    report_year: function () {
      if (!this.report_year) {
        this.report_year = new Date().getFullYear()
      }
      this.report_months = []
      for (let i = 1; i <= 12; i++) {
        this.report_months.push(String(this.report_year) + '-' + String(i).padStart(2, '0'))
      }
      this.getExecutionLineData()
    },
    emissions: function () {
      if (!this.emissions) {
        this.emissions = ['particulates', 'nox', 'so2', 'vocs', 'ammonia_nitrogen', 'codcr', 'total_phosphorus', 'total_nitrogen']
      }
      this.drawBarChart()
    }
  }
}
export default execution_line_chart



// WEBPACK FOOTER //
// ./src/pollution/js/execution_line_chart.js